import React, { useContext } from 'react';
import { BottomNavigation, Paper } from '@mui/material';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Card, Button } from "react-bootstrap";

import { loginRequest } from "../../authConfig";

// Components
import NavigationBar from '../NavigationBar/NavigationBar';

import { UserContext } from '../../context/UserContext';
import { hasCMSAccess } from '../../utils/auth';

const PageLayout = (props: any) => {

  const { instance, accounts } = useMsal();
  const user = useContext(UserContext).user;

  return (
    <div data-testid='page-layout-container' className='container-fluid page-layout-container'>
      {
        hasCMSAccess(user) &&
        <NavigationBar />
      }
      <br />
      <br />
      <AuthenticatedTemplate>
        {props.children}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Card className="text-center">
          <Card.Header>Welcome to FOX CMS </Card.Header>
          <Card.Body>
            <Card.Title> You are not authorized to see the content.</Card.Title>
            <Card.Text>
              Please Sign In or Sign Up if you dont have an account
            </Card.Text>
            <Button variant="outline-dark" onClick={() => instance.loginRedirect(loginRequest)}>Sign In / Sign Up</Button>
          </Card.Body>
        </Card>
      </UnauthenticatedTemplate>

      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
        >

          {
            hasCMSAccess(user) &&
            <p>Copyright &copy; 2022 Fox. All rights reserved.</p>
          }
        </BottomNavigation>
      </Paper>
    </div>
  );
};

export default PageLayout;
